<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Activity</md-icon>
                    </div>
                    <h4 class="title">Edit Activity</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="activity.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Description
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
<!--                                    <md-input v-model="activity.description" />-->
                                    <ckeditor
                                            :editor="editor"
                                            v-model="activity.description"
                                            :config="editorConfig"
                                    ></ckeditor>
                                    <validation-error :errors="apiValidationErrors.description" />
                                </md-field>
                            </div>
                        </div>

                        <select-input-horizontal
                                v-model="activity.payment_mode"
                                :options="paymentsMode"
                                placeholder="Select Payment Mode"
                                label="Payment Mode"
                                name="name"
                                track-by="name"
                                main-class="md-layout"
                                :allow-empty="false"
                                deselect-label="Can't remove"
                                label-class="md-layout-item md-size-25 md-form-label"
                                :error="apiValidationErrors.payment_mode"
                        ></select-input-horizontal>
                        <select-input-horizontal
                                v-model="activity.pay_code"
                                :options="paymentsMode"
                                placeholder="Select Payment Code"
                                label="Payment Code"
                                name="code"
                                track-by="code"
                                main-class="md-layout"
                                :allow-empty="false"
                                deselect-label="Can't remove"
                                label-class="md-layout-item md-size-25 md-form-label"
                                :error="apiValidationErrors.payment_code"
                        ></select-input-horizontal>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Activity Category
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activity.category.id" name="categories">
                                        <md-option
                                                v-for="category in available_categories"
                                                :key="category.id"
                                                :value="category.id"
                                        >
                                            {{ category.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Activity</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';
import SelectInputHorizontal from '../../../components/Inputs/SelectInputHorizontal';
export default {
    components: { SelectInputHorizontal,ValidationError, ckeditor: CKEditor.component },

    mixins: [formMixin],

    data: () => ({
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'Outdent',
                'Indent',
                'TextColor',
                'BGColor',
            ],
        },
        activity: {
            type: 'activities',
            name: null,
            description: null,
            payment_mode: null,
            pay_code: null,
            category: {
                id: null,
                type: 'categories',
            },
            relationshipNames: ['category'],
        },
        available_categories: [],

    }),

    created () {
        this.get();
        this.getCategories();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                // return service.get(id)
                //     .then((response)=>{
                //         console.log(response);
                //     });
                // console.log(this.$store.dispatch("activities/get", id));
                await this.$store.dispatch('activities/get', id);
                // console.log(this.$store.getters)
                this.activity = this.$store.getters['activities/activity1'];
                // console.log(this.activity);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('activities/update', this.activity);
                await this.$store.dispatch(
                    'alerts/success',
                    'Activity updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        getCategories () {
            this.$store.dispatch('categories/list').then(() => {
                this.available_categories = this.$store.getters['categories/dropdown'];
            });
        },

        goBack () {
            this.$router.push({ name: 'Activities List' });
        },
    },
};
</script>
